<template>
  <div>
    <v-row justify="center">
      <PointLabelLarge when="今日" :name="userName" :point-val="userTodayPoint" />
    </v-row>
    <v-row justify="center">
      <v-col cols="5" xs="5" sm="4" md="3" lg="2" class="vertical-no-padding-col">
        <NormalSimpleButtonSmall button-title="くわしく見る" @clickAction="openDetailIndividual" />
      </v-col>
    </v-row>
    <v-row justify="center" class="team_point-area">
      <v-col cols="6" xs="6" sm="6" md="3" lg="3">
        <PointLabelSmall when="今日" :name="teamName" :point-val="teamTodayPoint" />
      </v-col>
      <v-col cols="6" xs="6" sm="6" md="3" lg="3">
        <PointLabelSmall when="今週" :name="teamName" :point-val="teamWeeklyPoint" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="5" xs="5" sm="4" md="3" lg="2" class="vertical-no-padding-col">
        <NormalSimpleButtonSmall button-title="くわしく見る" @clickAction="openDetailTeam" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PointLabelLarge from "../Molecules/PointLabelLarge";
import PointLabelSmall from "../Molecules/PointLabelSmall";
import NormalSimpleButtonSmall from "../Atoms/NormalSimpleButtonSmall";

export default {
  name: "PointLabelArea",
  data: () => ({}),
  created() {
  },
  computed: {
    userTodayPoint() {
      const now_date = new Date().toString().substr( 0, 15 )
      let latestUserPoint = 0

      if (!this.userPoints.length){
        return 0
      }

      for (let userPoint of this.userPoints) {
        const createdAt = new Date(userPoint.created_at).toString().substr( 0, 15 )
        if (createdAt === now_date) {
          latestUserPoint = userPoint.point
        }
      }
      return latestUserPoint
    },
    teamTodayPoint() {
      const now_date = new Date().toString().substr( 0, 15 )
      let latestTeamPoint = 0

      if (!this.teamPoints.length){
        return 0
      }

      for (let teamPoint of this.teamPoints) {
        const createdAt = new Date(teamPoint.created_at).toString().substr( 0, 15 )
        if (createdAt === now_date) {
          latestTeamPoint = teamPoint.point
        }
      }
      return latestTeamPoint
    },
    teamWeeklyPoint() {
      let weeklyPoint = 0
      if (!this.teamPoints.length){
        return 0
      }
      for (let teamPoint of this.teamPoints) {
        weeklyPoint += teamPoint.point
      }
      return weeklyPoint
    }
  },
  methods: {
    openDetailIndividual() {
      this.$emit("openDetailIndividual");
    },
    openDetailTeam() {
      this.$emit("openDetailTeam");
    }
  },
  components: {
    PointLabelLarge,
    PointLabelSmall,
    NormalSimpleButtonSmall
  },
  props: ["userName", "teamName", "userPoints", "teamPoints"]
};
</script>

<style scoped>
.vertical-no-padding-col {
  padding: 0 12px;
}
.team_point-area {
  margin-top: 30px;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
